﻿@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../../constants/spacing.module.less';

.scanpage-section {
  h4 {
    margin: @space-0 @space-0 @space-16;
    font-weight: 500;
  }
  gap: @space-0;

  .scan-verify-section {
    display: flex;
    align-items: center;
    gap: @space-12;
    justify-content: space-between;
    padding-bottom: @space-16;
    margin-bottom: @space-24;
    border-bottom: 1px solid var(--grey-300);

    &:last-child {
      margin-bottom: @space-0;
      padding-bottom: @space-0;
      border-bottom: none;
    }

    p {
      margin: @space-0;
    }
    .scan-verify-dropdown-container {
      min-width: 240px;
    }
  }
}

.scan-verify-multiselect-dropdown {
  min-width: 240px;

  button {
    font-weight: 400;
    border: solid 1px var(--default--border-color--5);
  }
}
